export default __webpack_public_path__ + "static/media/Fleshcarver.6f34b122.jpg";